export default __webpack_public_path__ + "img/signed-in-7-days-reward-acf9c434641d3f59c246a78d5bb02dc2.png";